import styled from 'styled-components';

const RoutersWrapper = styled.div``;

export default RoutersWrapper;
